import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import esLocale from './locales/es/translation.json';
import enLocale from './locales/en/translation.json';

i18next.use(initReactI18next).init({
	fallbackLng: 'es',
	debug: import.meta.env.PROD !== true,
	resources: {
		es: {
			translation: esLocale,
		},
		en: {
			translation: enLocale,
		},
	},
});

export default i18next;
